export const ROLESID = Object.freeze({
  SUPERUSER: "Super User",
  CDVP: "CD VP",
  BRANCH_MANAGER: "Regional Sales Director",
  ASM: "Area Sales manager",
  SUPERVISOR: "Assistant Area Sales Manager",
  TEAM_LEAD: "OM DSS",
});
